import React from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import brandImage from "../assets/mcollectbrandimage.jpg";
import "../styles/Login.css";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../redux/authSlice/authSlice";
import { toast } from "react-toastify";
import { Baseurl } from "../baseurl";

const LoginSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

const Login = () => {
  const dispatch = useDispatch();
  const handleLogin = async (values, { setSubmitting }) => {
    console.log(values, "values");

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      // 🔗 Replace with your API
      const resp = await axios.post(
        `${Baseurl}/api/admin/login`,
        values,
        config
      );
      toast.success("Login successful");
      if (resp.data?.success) {
        await dispatch(loginSuccess(resp.data.admin));
      }
    } catch (error) {
      toast.error("Invalid email or password");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Container fluid className="login-page">
      <Row className="justify-content-center align-items-center vh-100">
        <Col md={6} lg={4}>
          <Card className="login-card shadow">
            <Card.Body>
              {/* Brand Section */}
              <div className="text-center mb-4">
                <img
                  src={brandImage}
                  alt="mCollect"
                  className="login-brand-image"
                />
                <h4 className="mt-3">mCollect Admin Panel</h4>
                <p className="text-muted tagline">
                  Smart Auctions. Secure Management.
                </p>
              </div>

              {/* Login Form */}
              <Formik
                initialValues={{ email: "", password: "" }}
                validationSchema={LoginSchema}
                onSubmit={handleLogin}
              >
                {({
                  handleSubmit,
                  handleChange,
                  values,
                  touched,
                  errors,
                  isSubmitting,
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                      <Form.Label>Email Address</Form.Label>
                      <Form.Control
                        type="email"
                        name="email"
                        placeholder="admin@example.com"
                        value={values.email}
                        onChange={handleChange}
                        isInvalid={touched.email && !!errors.email}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Password</Form.Label>
                      <Form.Control
                        type="password"
                        name="password"
                        placeholder="Enter password"
                        value={values.password}
                        onChange={handleChange}
                        isInvalid={touched.password && !!errors.password}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Button
                      type="submit"
                      style={{ background: "#304356" }}
                      className="w-100"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Logging in..." : "Login"}
                    </Button>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>

          <p className="text-center mt-3 text-white footer-text">
            © {new Date().getFullYear()} mCollect. All rights reserved.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
